import React from 'react';

const KPICard = ({ title, value, icon, color }) => {
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textAlign: 'center',
            flex: 1,
            margin: '10px',
            minWidth: '150px'
        }}>
            <div style={{ fontSize: '32px', color: color }}>{icon}</div>
            <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '10px' }}>{value}</div>
            <div style={{ color: '#666', marginTop: '5px' }}>{title}</div>
        </div>
    );
};

export default KPICard;